module.exports = __webpack_public_path__ + "static/media/bkg02d.911d589a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg02d.jpg
// module id = 465
// module chunks = 0